const langJA = {
	"GAS_FEES" : "ネブラスカのネットワークガス料金",
	"TX_WARNING" : "警告！ Nebulasストレス下での取引時間は現在不明です。",
	"COLLECT" : "収集する",
	"COLLECT_DESCRIPTION" : "あなたの心のコンテンツにデジタル資産を集めましょう！ 各カードはランダムに生成され、特定の統計情報と特性に対応する一意のIDを含みます。",
	"BATTLE" : "戦い",
	"TRADE" : "トレード",
	"GET_COLLECTIBLES" : "あなたの回収品を手に入れよう！",
	"PLEASE_WAIT" : "お待ちください ...",
	"VS" : "対",
	"BATTLE_NOW" : "今すぐバトル",
	"CREATE_AUCTION" : "オークションを作成する",
	"TRADE_DESCRIPTION" : "高い評価を受けたユニークなカードをお持ちですか？ それは潜在的に有益な可能性があります！ あなたの価格に名前をつけて、オークションを通じてポテンシャルバイヤーを誘致してください。",
	"BATTLE_DESCRIPTION" : "あなたが所有するカードを戦闘してレベルアップさせてください！ 勝利ごとに新しいカードを獲得します。 しかし、忘れてしまうと、カードを失うことになります。 高い評価を受けたカードはより価値があるので、戦いは非常にやりがいのあるものです。",
	"BANNER_HEADER" : "収集、戦い、貿易",
	"BRAND_HEADER" : "BATTLE BLOCKS",
	"BRAND_SUBHEADER" : "ブロックチェーン上のバトルレディコレクティブデジタル資産",
	"LOADING" : "読み込んでいます...",
	"CARDS_CREATED" : "作成されたカード",
	"PENDING_TRANSACTION" : "保留中の取引",
	"SAVE" : "セーブ",
	"USER_LOADING" : "ユーザーの読み込み中...",
	"CARDS_LOADING" : "カード読み込み中...",
	"BATTLE_CARDS" : "バトルカード",
	"WINS" : "勝つ",
	"LOSSES" : "損失",
	"CARD" : "カード",
	"LEVEL" : "レベル",
	"TOTAL" : "合計",
	"NO_CARDS" : "あなたはカードを持っていません",
	"INSTALL_EXTENSION" : "<strong>ねえ！</strong> インストールしてログインしてください <a href='https://github.com/ChengOrangeJu/WebExtensionWallet' target='_blank'>Nebulas Web Extension Wallet</a> Battle Blocksサービスを使用する。",
	"NEBULAS_ERROR" : "<strong>警告！</strong> Nebulas Blockchainからデータを読み込む際に1つ以上のエラーがありましたが、再読み込みが必要な場合があります。",
	"ERROR_MESSAGE" : "エラーメッセージ",

	//About Page
	"ABOUT_HEADER" : "バトルブロックについて",
	"ABOUT" : "Battle Blocks® は、デジタルアセットカードゲームです。 <a href='#'>Nebulas</a> ブロックチェイン。 すべての資産はブロックチェーンテクノロジによって保存され、保護されており、デジタルトレーディングカードを使用して簡単に購入、取引、戦闘を行うことができます。",
	"TOKENS_HEADER" : "バトルトークン",
	"TOKENS" : "すべての勝利で5つのバトルトークンを獲得する。 あなたのカードや他のクールなもの（開発中）を平準化するためにあなたのトークンを使用してください。 バトルトークンは、NRC-20相当、譲渡日を発表するために償還されます。",
	"GEN_0_HEADER" : "Generation-0カード",
	"GEN_0" : "すべての世代は限られた供給力を持ち、次世代に勝る利点があります。 Generation-0には10,000枚のカードが封入されており、より若い競争相手に勝るユニークな能力とスキルにアクセスできるようになります。",
	"GEN_X_HEADER" : "Generation-Xカード",
	"GEN_X" : "Generation-Xカードはトップパフォーマーにのみ提供され、Leaderboardsページで見ることができ、収益をオークションするかどうかを決定します。 これらのカードには新しい芸術があり、他の世代では利用できない新しいスキルがあります。",
	"FEES_HEADER" : "バトルブロック料金",
	"FEES_1" : "現在、ネブラスカのネットワークガス料金を除いて、料金はありません。",
	"FEES_2" : "限定販売のカードやユーザーの販売価格に応じて、オークションには手数料がかかります。",
	"SUBJECT_TO_CHANGE" : "* 料金は変更されることがあります。",

	//Footer
	"FOOTER": {
		"MISSION" : "ミッション",
		"MISSION_TEXT" : "Blockchainベースのゲームを再定義し革新し、品質、芸術性、エンターテインメント性、そして楽しさを高めます。",
		"EMAIL_TEXT" : "お問い合わせはこちらへ",
		"USEFUL_LINKS" : "役に立つリンク",
		"RULES" : "ルール",
		"ABOUT" : "約",
		"BATTLES" : "戦い",
		"AUCTIONS" : "オークション",
		"LEADERBOARDS" : "リーダーボード",
		"TERMS_OF_USE" : "利用規約",
		"SOCIAL" : "ソーシャル",
		"CONTRACT" : "契約する",
	},

	//Auction
	"AUCTION" : {
		"CREATE" : "オークションの作成",
		"LOADING" : "オークションの読み込み中...",
		"NONE" : "オークションなし",
		"SOLD" : "売れた",
		"PRICE" : "価格",
		"CREATED_ON" : "作成日",
		"BUY" : "購入",
	}

};

export default langJA;


// WEBPACK FOOTER //
// ./src/util/translations/lang_ja.js